export const DATE_FORMAT = 'YYYY-MM-DD';

export const MONTH_FORMAT = 'YYYY-MM';

export const MODAL_TYPE_AUTO = 'auto';
